<div class="row business-info">
    <div class="col-md-12">
        <br />
        <h4>Update {{selectParentTermName$ | async}} Account Information</h4>
        <br />
    </div>
</div>

<form
    class="row"
    [formGroup]="formGroup"
    name="business-account-form"
>
    <div class="col-md-6">
        <div class="form-group">
            <label>Company Name</label>
            <input
                type="text"
                class="form-control"
                required
                formControlName="companyName"
                name="companyName"
                [ngClass]="{ 'is-invalid': submitted && f.companyName.errors }"
            />

        </div>

        <div class="form-group">
            <label>Industry</label>
            <input
                type="text"
                class="form-control"
                formControlName="industry"
                name="industry"
            />
        </div>

        <div class="form-group">
            <label>Contact First Name</label>
            <input
                type="text"
                class="form-control"
                formControlName="contactFirstName"
                name="contactFirstName"
                [ngClass]="{ 'is-invalid': submitted && f.contactFirstName.errors }"
            />
            <small
                class="error"
                *ngIf="f.contactFirstName.errors?.pattern"
            >Only English characters are accepted.</small>
            <small
                class="error"
                *ngIf="submitted && f.contactFirstName.errors?.required"
            >Please enter a contact first name.</small>
        </div>

        <div class="form-group">
            <label>Contact Last Name</label>
            <input
                type="text"
                class="form-control"
                formControlName="contactLastName"
                name="contactLastName"
                [ngClass]="{ 'is-invalid': submitted && f.contactLastName.errors }"
            />
            <small
                class="error"
                *ngIf="f.contactLastName.errors?.pattern"
            >Only English characters are accepted.</small>
            <small
                class="error"
                *ngIf="submitted && f.contactLastName.errors?.required"
            >Please enter a contact last name.</small>
        </div>

        <div class="form-group">
            <label>Title</label>
            <input
                type="text"
                class="form-control"
                formControlName="salutation"
                name="salutation"
            />
        </div>

        <div class="form-group">
            <label>Email</label>
            <input
                type="text"
                class="form-control"
                formControlName="email"
                name="email"
            />
        </div>

        <div class="form-group">
            <label>Phone</label>
            <input
                type="text"
                class="form-control"
                formControlName="phone"
                name="phone"
                [ngClass]="{ 'is-invalid': submitted && f.phone.errors }"
            />
            <small
                class="error"
                *ngIf="f.phone.errors?.pattern"
            >
                Please enter a phone number that contains only numbers and no spaces, dashes or brackets</small>
            <small
                class="error"
                *ngIf="submitted && f.phone.errors?.required"
            >Please enter a phone number.</small>
        </div>
    </div>

    <div class="col-md-6">

        <div class="form-group">
            <label>Country</label>
            <select
                class="form-control"
                formControlName="countryId"
                name="countryId"
                (change)="getRegions(formGroup.controls.countryId.value)"
            >
                <option
                    *ngFor="let country of countries"
                    [value]="country.id"
                >
                    {{country.name}}
                </option>
            </select>
        </div>

        <div class="form-group">
            <label>Address/Street/PO Box</label>
            <input
                type="text"
                class="form-control"
                formControlName="addressLine1"
                name="addressLine1"
            />
        </div>

        <div class="form-group">
            <input
                type="text"
                class="form-control"
                formControlName="addressLine2"
                name="addressLine2"
            />
        </div>

        <div class="form-group">
            <label>City</label>
            <input
                type="text"
                class="form-control"
                formControlName="city"
                name="city"
            />
        </div>

        <div
            class="form-group"
            *ngIf="regions?.length > 0; else useRegionAbbrOrName"
        >
            <label>Province/State</label>
            <select
                class="form-control"
                name="region"
                formControlName="region"
            >
                <option
                    *ngFor="let region of regions"
                    [value]="region.abbreviation"
                >
                    {{region.name}}
                </option>
            </select>
        </div>

        <ng-template #useRegionAbbrOrName>
            <div class="form-group">
                <label>Province/State</label>
                <input
                    type="text"
                    class="form-control"
                    formControlName="region"
                    name="region"
                    maxlength="20"
                />
            </div>
        </ng-template>

        <div class="form-group">
            <label>Postal/Zip Code</label>
            <input
                type="text"
                class="form-control"
                formControlName="postalCode"
                name="postalCode"
                maxlength="20"
            />
        </div>
    </div>
</form>
